<template>
  <div>
    <VoteComment
      v-if="showVoteModal"
      @close="showVoteModal = false"
      ref="commentModal"
      @saveComment="saveComment"
      @deleteComment="deleteComment"
      :isTpg="isTpg"
      :voteReasons="voteReasons"
      :track="trackForComment"
    ></VoteComment>

    <div v-if="showOops" class="alert alert-danger" role="alert">
      Oops, we’re having trouble right now, please check soon. If the problem persists,
      please contact us.
    </div>

    <nav class="navbar" :class="{ isTpg: isTpg }">
      <div class="col-xs-4" v-if="!isTpg">
        <div class="gv-svg" v-on:click="goHome" style="cursor: pointer">
          <!-- <img alt="Gray V" border="0" class="goHome"> -->
        </div>
      </div>
      <div class="col-xs-4 logo" @click="goHome" :class="{ isTpg: isTpg }" v-else>
        <div style="margin-left: 10px; margin-top: -10px; cursor: pointer">
          <SVGLogo :definedColor="logoColor" allBlack="true" class="goHome"></SVGLogo>
        </div>
      </div>

      <div class="col-xs-8 username-container" :class="{ isTpg: isTpg }">
        <span class="username" v-if="userObject"
          >{{ userObject.email }}&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span>
          <a @click="logout()" v-if="userAuthenticated" class="logout"> Logout </a>
        </span>
      </div>
    </nav>

    <div class="macontainer">
      <div v-if="mainVueState === pageStates.LOGIN">
        <Login
          @userLoggedIn="checkAuth(is_demo_signup)"
          @logEvent="logEvent"
          :isTpg="isTpg"
        ></Login>
      </div>
      <div v-if="mainVueState == pageStates.FORGOT">
        <ForgotPassword :isTpg="isTpg"></ForgotPassword>
      </div>
      <div v-else-if="mainVueState == pageStates.FORCE_PASSWORD_RESET">
        <ForcePasswordReset
          :isTpg="isTpg"
          @userResetPassword="fetchUserInfo"
          :userObject="userObject"
        >
        </ForcePasswordReset>
      </div>

      <div v-else-if="mainVueState == pageStates.WORKSPACE">
        <div v-if="userInfoIsLoaded">
          <div class="menu-container" :class="{ isOpen: isOpen, isTpg: isTpg }">
            <main-menu
              :userHasOnlinePlayer="userHasOnlinePlayer"
              :isLoadingRemainingPlayers="isLoadingRemainingPlayers"
              :menuIsOpen="isOpen"
              :userInfo="userObject"
              :menuLastUpdated="menuLastUpdated"
              :loggedOut="loggedOut"
              :locationZones="locationZones"
              :allPlayers="allPlayers"
              :allSamples="allSamples"
              :isTpg="isTpg"
              @logEvent="logEvent"
              @logClicky="logClicky"
              @getFirstPlayer="getFirstPlayer"
              @loadRemainingPlayers="loadRemainingPlayers"
            >
            </main-menu>
          </div>

          <router-view
            v-slot="{ Component }"
            :playerState="playerState"
            :playlistUrl="activePlaylistURL"
            :isLoadingRemainingPlayers="isLoadingRemainingPlayers"
            :currentTrack="currentTrack"
            :shortClipPlaybackTypeID="shortClipPlaybackTypeID"
            :userHasAccessToAtLeastOnePlayer="userHasOnlinePlayer"
            :userObject="userObject"
            :userInfo="userObject"
            :samplePlaylistAndVotes="samplePlaylistAndVotes"
            :allPlayers="allPlayers"
            :selectedSample="selectedSample"
            :allowVoting="allowVoting"
            :locationZones="locationZones"
            :isTpg="isTpg"
            @logEvent="logEvent"
            @shuffleSample="shuffleSample"
            @toggleSpotlightPlayPause="toggleSpotlightPlayPause"
            @fetchSamplePlaylist="fetchSamplePlaylist"
            @samplePlayClick="samplePlayClick"
            @playlistSelected="playlistSelected"
            @playlistUpdated="playlistUpdated"
            @trackManuallySelected="trackManuallySelected"
            @shortClipClicked="shortClipClicked"
            @sampleVoteClicked="sampleVoteClicked"
            @voteCommentClicked="voteCommentClicked"
            @playSpotlightStation="playSpotlightStation"
            @logClicky="logClicky"
          >
            <!-- <transition name="workspace-slide"> -->
            <div
              class="workspace-container"
              :class="{ isOpen: isOpen, isTpg: isTpg }"
              v-if="isOpen"
            >
              <component :is="Component" />
            </div>
            <!-- </transition> -->
          </router-view>
        </div>
      </div>

      <div v-else>
        <!-- Silence is golden -->
      </div>
    </div>

    <br /><br /><br /><br /><br /><br /><br /><br /><br />
    <clientweb-player
      :isTPG="isTpg"
      :isInteractive="isInteractive"
      :allowVoting="allowVoting"
      :playerState="playerState"
      :playlistUrl="activePlaylistURL"
      :currentTrack="currentTrack"
      :shortClipPlaybackTypeId="shortClipPlaybackTypeID"
      :isSample="isSample"
      :stationCode="stationCode"
      :playlistId="playlistId"
      :currentTrackPosition="currentTrackPosition"
      :currentTrackDuration="currentTrackDuration"
      @togglePlay="togglePlay"
      @logEvent="logEvent"
      @skipTrack="skipTrack"
      @newTrackInfo="newTrackInfo"
      @updateCurrentTrackWithVote="updateCurrentTrackWithVote"
      @sampleVoteClicked="sampleVoteClicked"
      :playlistOrigin="playlistOrigin"
      :playlistOriginRoute="playlistOriginRoute"
      :shuffleIt="shuffleIt"
      :loggedOut="loggedOut"
      @newPlaylistVotes="newPlaylistVotes"
      @voteCommentClicked="voteCommentClicked"
      @playerHasBeenOpened="playerHasBeenOpened"
      v-if="userAuthenticated == true && !noSamplesNoPlayers"
    ></clientweb-player>

    <audio id="si-web-player" playsinline></audio>

    <div class="midtempo-link" :class="{ isTpg: isTpg, playerIsOpen: playerIsOpen }">
      <a href="https://www.midtempo.co" target="NEW">Visit midtempo.co</a>
      <a
        target="NEW"
        href="https://www.instagram.com/midtempo.co"
        style="margin-left: 7px"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          class="midtempo-link-svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="#ffffff"
        >
          <path
            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
          ></path></svg
      ></a>
    </div>

    <br /><br /><br /><br /><br />
  </div>
</template>

<script>
import $ from "jquery";
import siWebPlayer from "siwebplayer";
import MainMenu from "./views/Menu/MainMenu.vue";
import SVGLogo from "./shared/SVGLogo-TPG.vue";
import Login from "./views/Auth/Login.vue";
import ForgotPassword from "./views/Auth/ResetPassword.vue";
import ForcePasswordReset from "./views/Auth/ForcePasswordReset.vue";
import ClientwebPlayer from "./shared/ClientwebPlayer.vue";
import VoteComment from "./shared/VoteComment.vue";
import Player from "/src/player.js"; // T232 01-25-2022
import { initCrispForUser, resetCrispSession } from "@/services/crispChat.js";

const Querystring = require("querystring");

// import ResetPassword from './Auth/ResetPassword.vue';

export const PageStates = {
  WORKSPACE: 0,
  FORCE_PASSWORD_RESET: 1,
  FORGOT: 2,
  LOGIN: 3,
};

export default {
  components: {
    MainMenu,
    SVGLogo,
    Login,
    ForgotPassword,
    ForcePasswordReset,
    ClientwebPlayer,
    VoteComment,
  },
  data() {
    return {
      isTpg: false,
      siPlayer: null,
      playlistVotes: "",
      playlistTracks: "",
      isInteractive: false,
      allowVoting: false,
      playlistOrigin: "",
      playlistOriginRoute: "",
      playerState: "paused",
      stationCode: "",
      currentTrack: null,
      currentTrackPosition: 0,
      currentTrackDuration: 0,
      shortClipPlaybackTypeID: "0",
      ogClick: false, // IF user has clicked play yet.  Needed for Safari,
      isSample: false,
      userAuthenticated: false,
      forcePasswordReset: false,
      isOpen: false,
      userObject: { email: "" },
      selectedBG: null,
      mainBG: "mainBackground.jpeg",
      randomBGs: [
        "login_back1.jpg",
        "login_back2.jpg",
        "login_back3.jpg",
        "login_back4.jpg",
        "login_back5.jpg",
      ],
      shuffleIt: new Date(),
      accountingServiceTypeID: "11",
      userAdminServiceTypeID: "13",
      itServiceTypeID: "16",
      menuLastUpdated: null,
      loggedOut: "",
      commentIsVisible: false,
      voteReasons: "",
      selectedSample: "",
      samplePlaylistAndVotes: "",
      wslSamplePlaylistAndVotes: "",
      activePlaylistURL: "",
      activePlaylist: "",
      trackForComment: "",
      usersSamples: "",
      demoSignupStatusId: "",
      demoSignupZoneId: "",
      isRandomStation: false,
      playlistId: "",
      noSamplesNoPlayers: false,
      isInitialPlaylistLoad: true,
      allPlayers: [],
      userHasOnlinePlayer: false,
      locationZones: "",
      indexedLocationZones: "",
      allSamples: "",
      gv_clicky_id: "101098508",
      playerIsOpen: false,
      isItMode: false,
      isLoadingRemainingPlayers: true,
      pageStates: PageStates,
      userInfoIsLoaded: false,
      showOops: false,
      showVoteModal: false,
    };
  },
  mounted() {
    this.siPlayer = new siWebPlayer();
    this.setBrand();

    this.checkAuth();

    this.isOpen = false;

    // Start with open if route defined
    const routeName = this.$route.name;
    routeName ? this.open() : this.close();

    const event_data = {
      web_tracking_event_type_id: 2,
      page_name: "Clientweb Home",
    };
    this.logEvent(event_data);

    this.loadSIWPEventListeners();
  },
  methods: {
    setBrand() {
      const pageUrl = window.location.href;
      if (pageUrl.includes("theplaylistgeneration")) {
        this.isTpg = true;
      }
      // this.makeBackground();
    },
    loadSIWP(contactLoginStationCode, tracks, royaltySettings) {
      this.siPlayer.setup({
        repeat: true,
        shouldLog: false,
        tracks,
        royaltySettings,
        stationCode: contactLoginStationCode,
      });
    },
    loadSIWPEventListeners() {
      const self = this;
      this.siPlayer.on("playlistItem", () => {
        self.playerStateChange();

        const playlist = self.siPlayer.getPlaylist();
        const index = self.siPlayer.getPlaylistIndex();
        self.currentTrack = playlist[index];
      });
      this.siPlayer.on("stateChange", () => {
        // updatePlayButton();
        self.playerStateChange();
      });
      this.siPlayer.on("siwpError", (event) => {
        console.log(`E ${JSON.stringify(event)}`);
      });
      this.siPlayer.on("time", (event) => {
        self.currentTrackPosition = event.position;
        self.currentTrackDuration = event.duration;
        if (self.shortClipPlaybackTypeID == "1" || self.shortClipPlaybackTypeID == "2") {
          if (event.position > 0.8 && event.position < 1.2) {
            self.siPlayer.seek(30);
          }
          if (event.position >= 40) {
            self.siPlayer.next();
          }
        }

        // updateTime(event);
      });
    },
    playerStateChange() {
      this.playerState = this.siPlayer.getState();
      // console.log('STATE CHANGE ' + this.siPlayer.getState());
    },
    playerHasBeenOpened() {
      this.playerIsOpen = true;
    },
    // Permitted params: web_tracking_event_type_id,page_name,location_zone_id,track_code,contact_login_station_id,vote_value,session_token,message
    logEvent(data) {
      if (!data) return;
      if (!data.web_tracking_event_type_id) return;

      const event_data = { web_tracking_event_type_id: data.web_tracking_event_type_id };
      if (data.page_name) {
        event_data.page_name = data.page_name;
      }
      if (data.location_zone_id) {
        event_data.location_zone_id = data.location_zone_id;
      }
      if (data.track_code) {
        event_data.track_code = data.track_code;
      }
      if (data.contact_login_station_id) {
        event_data.contact_login_station_id = data.contact_login_station_id;
      }
      if (data.vote_value) {
        event_data.location_zone_id = data.vote_value;
      }
      if (data.session_token) {
        event_data.location_zone_id = data.session_token;
      }
      if (data.message) {
        event_data.location_zone_id = data.messagexs;
      }

      const eventQueryString = Querystring.stringify(event_data);
      this.$http.post("/event", eventQueryString).then(() => {
        // console.log("response " + response);
      });
    },
    logClicky() {
      // let routeName = this.$route.name;
      // if (routeName == "" || !routeName) {
      //     routeName = "Home";
      // }
      // let title = action;
      // if (!title || title == "") {
      //     title = "Page view";
      // }
      // var clicky_custom = {
      //     cookies_disable: 0,
      //     visitor_consent: 1,
      //     href: routeName,
      //     title: title,
      //     visitor: {
      //         username: this.userObject.email,
      //         email: this.userObject.email
      //     },
      //     timer: 200
      // };
      // let headers = {
      //     'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept, Authorization",
      //     "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      //     "Access-Control-Allow-Credentials":"true"
      // };
      // let clicky_site_ids = clicky_site_ids || [];
      // clicky_site_ids.push(this.gv_clicky_id);
      // window.clicky_site_ids = clicky_site_ids;
      // window.clicky_custom = clicky_custom;
      // var url = "https://static.getclicky.com/123.js";
      // this.$http.get(url,{headers}).then(function() {
      // }, () => {
      //     //console.log(response);
      // });
    },
    logClickySamplePlay() {
      const userEmail = this.userObject.email;
      const playlistName = this.selectedSample.name;
      const url = `https://in.getclicky.com/in.php?site_id=101098508&sitekey_admin=b4aae024bd1d25ba91ca5b3cb3bdf342&session_id=76.103.64.52&type=custom&custom[username]=${userEmail}&custom[Playlist_Play]=${userEmail}_${playlistName}`;
      this.$http.post(url).then(
        () => {},
        () => {
          // console.log(response);
        }
      );
    },
    forgotPassword() {
      this.mainVueState = PageStates.FORGOT;
      location.reload();
    },
    /**
     * load and play the sample selected in sample picker.
     *
     * @param object sample
     */
    sampleOnlySelected(sample) {
      this.$router.push({ name: "sample", params: { id: sample.id } });
      this.playlistOrigin = `Sample: ${sample.name}`;
      this.playlistOriginRoute = `/samples/${sample.id}`;
      this.fetchSamplePlaylist(sample);
    },
    /**
     * Samples.vue has a new sample and needs tracks and votes.
     *
     * @param object sample
     */
    fetchSamplePlaylist(sample) {
      this.selectedSample = sample;
      this.getSamplePlaylistTracks();
    },
    makeWslHttps(playlist) {
      const playlistWithWslHttps = [];
      for (let i = 0; i < playlist.length; i++) {
        playlist[i].file = playlist[i].file.replace("http", "wslhttps");

        playlistWithWslHttps.push(playlist[i]);
      }

      return playlistWithWslHttps;
    },
    /**
     * Uses json_playlist_url to get playlist then get votes.
     */
    getSamplePlaylistTracks() {
      const playlistURL = this.selectedSample.json_playlist_url;
      const self = this;
      const tracksWithVotes = [];

      $.ajax({
        url: playlistURL,
        cache: false,
        dataType: "json",
        success(data) {
          for (let i = 0; i < data.length; i++) {
            const trackObject = self.makeTrackObject(data[i]);
            tracksWithVotes.push(trackObject);
          }

          self.samplePlaylistAndVotes = tracksWithVotes;

          self.getSamplePlaylistVotes();
        },
      });

      // this.$http.get(playlistURL).then(function(response) {
      //     for (var i = 0; i < response.length; i++) {

      //         var trackObject = self.makeTrackObject(response[i]);
      //         tracksWithVotes.push(trackObject);
      //     }

      //     self.samplePlaylistAndVotes = tracksWithVotes;

      //     self.getSamplePlaylistVotes();
      // });
    },
    makeTrackObject(track) {
      const obj = {};
      obj.title = track.title;
      obj.code = track.code;
      obj.artist = track.artist;
      obj.file = track.file;
      obj.cover = track.cover;
      obj.genstamp = track.genstamp;
      obj.override_type_id = track.override_type_id;
      obj.vote_reason_id = track.vote_reason_id;
      obj.comment = track.comment;

      return obj;
    },
    /**
     * Adds votes to playlist tracks.
     */
    getSamplePlaylistVotes() {
      let sampleVotes = "";
      const self = this;
      this.$http.get(`/sample_playlists/${this.selectedSample.code}`).then(
        (response) => {
          if (response) {
            if (response.data) {
              sampleVotes = response.data.data.votes;
              self.addVotesToSamplePlaylist(sampleVotes);
            } else {
              self.addVotesToSamplePlaylist();
            }
          }
        },
        () => {
          self.addVotesToSamplePlaylist();
        }
      );
    },
    /**
     * Checks if track has a vote in existingVotes
     *
     * @param object track
     * @return 1 (positive), 0 (negative), -1 (comment only)
     */
    addVotesToSamplePlaylist(sampleVotes) {
      // Go through
      const playlistWithVotes = [];
      for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
        playlistWithVotes.push(this.samplePlaylistAndVotes[i]);

        if (!sampleVotes) {
          playlistWithVotes[i].override_type_id = "";
          playlistWithVotes[i].comment = "";
          playlistWithVotes[i].vote_reason_id = "";
        } else {
          for (const key in sampleVotes) {
            if (!Object.prototype.hasOwnProperty.call(sampleVotes, key)) continue;

            const obj = sampleVotes[key];

            if (key == this.samplePlaylistAndVotes[i].code) {
              playlistWithVotes[i].override_type_id = obj.override_type_id;
              playlistWithVotes[i].comment = obj.comment;
              playlistWithVotes[i].vote_reason_id = obj.vote_reason_id;
            }
          }
        }
      }

      this.samplePlaylistAndVotes = playlistWithVotes;

      if (this.isInitialPlaylistLoad) {
        this.loadSIWP(this.selectedSample.code, this.samplePlaylistAndVotes, {
          t: this.selectedSample.code,
          track_stream_type_id: 5,
        });
        // console.log("LOAD-addVotesToSamplePlaylist" + JSON.stringify(this.samplePlaylistAndVotes[0]))
        this.currentTrack = this.samplePlaylistAndVotes[0];
        this.isInitialPlaylistLoad = false;
        // document.getElementById('playButton').click();
        // jwplayer('gvPlayer').stop();
      }
    },
    /**
     * Vote clicked on sample page.
     *
     * @param
     * @return
     */
    sampleVoteClicked(track, loveOrLeave) {
      if (track.override_type_id == loveOrLeave) {
        if (this.canDeleteVote(track)) {
          this.deleteSampleVote(track);

          // Update track in array
          for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
            if (this.samplePlaylistAndVotes[i].code == track.code) {
              this.samplePlaylistAndVotes[i].override_type_id = null;
              loveOrLeave = "";
            }
          }
        } else {
          this.updateSamplePlaylistVote(track, "-1");
        }
      } else {
        this.updateSamplePlaylistVote(track, loveOrLeave);
      }

      // Update current track if selected
      if (track.code == this.currentTrack.code) {
        this.currentTrack.override_type_id = loveOrLeave;

        // Determine whether it's deleted
        if (track.override_type_id == this.currentTrack.override_type_id) {
          this.currentTrack.override_type_id = "";
          this.currentTrack.vote_reason_id = "";
          this.currentTrack.comment = "";
        }
      }

      const event_data = {
        web_tracking_event_type_id: 1,
        page_name: `${this.samplePlaylistAndVotes.name} Sample List`,
        track_code: track.code,
        vote_value: loveOrLeave,
      };
      this.logEvent(event_data);
    },
    updateSamplePlaylistVote(track, loveOrLeave) {
      // Update track in database
      this.postVote(track, loveOrLeave);

      // Update track in array
      for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
        if (this.samplePlaylistAndVotes[i].code == track.code) {
          this.samplePlaylistAndVotes[i].override_type_id = loveOrLeave;
        }
      }
    },
    canDeleteVote(track) {
      if (track.comment) {
        return false;
      }
      if (track.vote_reason_id) {
        return false;
      }

      return true;
    },
    postVote(track, loveOrLeave) {
      let voteString = "";
      if (loveOrLeave == 1) {
        voteString = "positive";
      } else if (loveOrLeave == 2) {
        voteString = "negative";
      } else if (loveOrLeave == -1) {
        voteString = "neutral";
      }

      const trackVote = Querystring.stringify({
        station_code: this.selectedSample.code,
        track_code: track.code,
        override_vote_type: voteString,
      });
      this.$http.post("/station/vote", trackVote).then(() => {});
    },
    deleteSampleVote(track) {
      this.$http
        .delete(`/station/vote/${this.selectedSample.code}/${track.code}`)
        .then(() => {});
    },
    samplePlayClick() {
      this.isSample = "true";
      this.activePlaylist = this.selectedSample;

      if (this.activePlaylistURL == this.selectedSample.json_playlist_url) {
        this.togglePlay();
      } else {
        // New playlist
        this.activePlaylistURL = this.selectedSample.json_playlist_url;
        this.allowVoting = this.selectedSample.clientweb_interactive;
        this.shortClipPlaybackTypeID = this.selectedSample.short_clip_playback_type_id;
        this.isInteractive = this.selectedSample.clientweb_interactive;
        this.playlistOrigin = `Sample: ${this.selectedSample.name}`;
        this.playlistOriginRoute = `/samples/${this.selectedSample.id}`;
        this.$nextTick(function () {
          this.currentTrack = this.samplePlaylistAndVotes[0];
        });

        this.loadSIWP(
          this.selectedSample.code,
          this.samplePlaylistAndVotes.slice(0, 15),
          { t: this.selectedSample.code, track_stream_type_id: 5 }
        );
        // this.siPlayer.playlistItem(0);
        // console.log("LOAD-samplePlayClick" + JSON.stringify(this.samplePlaylistAndVotes[0]))
        this.siPlayer.play();
        // this.togglePlay();

        // this.logClickySamplePlay();
      }
    },
    /**
     * Determines whether user has sample tracks.  If so, display menu item
     */
    checkForSamples() {
      const self = this;
      this.$http.get("/sample_playlists").then((response) => {
        self.allSamples = response.body;
      });
    },
    loadInitialSample() {
      this.isInitialPlaylistLoad = true;
      const self = this;
      this.$http.get("/sample_playlists").then((response) => {
        const samples = response.data;
        self.usersSamples = samples;
        self.isSample = "true";

        if (self.usersSamples.length > 0) {
          self.selectedSample = self.usersSamples[0];
          self.activePlaylist = self.selectedSample;
          self.fetchSamplePlaylist(self.selectedSample);

          self.playlistOrigin = `Samples: ${self.selectedSample.name}`;
          self.playlistOriginRoute = `/samples/${self.selectedSample.id}`;
          self.activePlaylistURL = self.selectedSample.json_playlist_url;
          self.allowVoting = self.selectedSample.clientweb_interactive;
          self.shortClipPlaybackTypeID = self.selectedSample.short_clip_playback_type_id;
          self.isInteractive = self.selectedSample.clientweb_interactive;

          self.$router.push({ name: "sample", params: { id: self.selectedSample.id } });

          self.getSamplePlaylistTracks();
        } else {
          self.noSamplesNoPlayers = true;

          // alert("Please contact a GrayV representative for some samples.");
        }
      });
    },
    /**
     * If user has access token, get their userInfo, load random station
     *
     * @param
     * @return
     */
    checkAuth() {
      let access_token = localStorage.getItem("si_access_token");
      access_token = typeof access_token === "undefined" ? null : access_token;
      // TODO: We should check that the token is still valid. At this point, I can use "111" for my token and it appears valid
      if (access_token) {
        this.userAuthenticated = true;
        this.fetchUserInfo();
        this.getVoteReasons();
        this.checkForSamples();
      } else {
        this.userAuthenticated = false;
        this.userInfoIsLoaded = true;
      }

      this.makeBackground();
    },
    getLocationZones() {
      const self = this;
      this.$http.get("/location_zone").then(
        (response) => {
          const { locations } = response.data;
          const { location_zones } = response.data;

          self.locationZones = self.matchLocationsAndZones(locations, location_zones);
          // Vue.prototype.$allLocationZones = this.locationZones;

          // T369 - (07-29-2002)
          // Get players - if first attempt fails due to the 'initial' player is currently offline then try again bypassing
          // using cache (player cookies), thereby calling the first endpoint without a playerUniqueId and playerTypeId.
          (async () => {
            const success = await self.getFirstPlayer();
            if (!success) {
              self.getFirstPlayer(true); // try again bypass the cookie for the player
            }
          })()
        },
        (response) => {
          console.log(
            `ERROR GETTING LOCATION ZONES ${JSON.stringify(response.data.message)}`
          );
          self.isLoadingRemainingPlayers = false;
          self.loadSetupState();
        }
      );
    },
    matchLocationsAndZones(locations, location_zones) {
      const matchedLocationsAndZones = [];

      for (let i = 0; i < location_zones.length; i++) {
        const { location_id } = location_zones[i];
        const location_name = this.getLocationNameFromId(locations, location_id);
        const location_zone_name = location_zones[i].name;
        const location_zone_id = location_zones[i].id;

        const location_zone = {
          location_name,
          location_id,
          location_zone_name,
          location_zone_id,
        };

        matchedLocationsAndZones.push(location_zone);
      }

      return matchedLocationsAndZones;
    },
    getLocationNameFromId(locations, location_id) {
      let location_name = "";
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].id == location_id) {
          location_name = locations[i].name;
        }
      }
      return location_name;
    },
    /**
     * Loads a random playlist into player
     */
    // loadRandomStation: function() {
    //    this.$http.get('api/spotlight/random').then(function(response) {
    //       var randomStation = response.data;
    //       var jsonURL = randomStation.json_playlist_url;

    //       this.isSample = false;
    //       this.stationCode = randomStation.location_zone_custom_playlist.code;

    //       this.playlistOrigin = "What's on @ Gray V: " + randomStation.name;
    //       this.playlistOriginRoute = '/whats-on';
    //       this.allowVoting = false;
    //       this.isInteractive = false;
    //       this.isRandomStation = true;
    //       this.activePlaylistURL = jsonURL;

    //       this.playlistId = randomStation.id;

    //       this.loadPlaylistFromURL(jsonURL);
    //   });
    // },
    /**
     * Returns playlist from url
     *
     * @param string url
     */
    loadPlaylistFromURL(url) {
      const self = this;
      const tracksWithVotes = [];

      $.ajax({
        url,
        cache: false,
        dataType: "json",
        success(data) {
          for (let i = 0; i < data.length; i++) {
            const trackObject = self.makeTrackObject(data[i]);
            tracksWithVotes.push(trackObject);
          }
          const urlParams = new URLSearchParams(url);
          let stationCode = "";
          if (urlParams.get("sid")) {
            stationCode = urlParams.get("sid");
          }
          self.loadSIWP(stationCode, tracksWithVotes, {
            t: this.selectedSample.code,
            track_stream_type_id: 5,
          });
          self.activePlaylist = tracksWithVotes;
        },
      });

      // $.get(url, function( data ) {
      //   for (var i=0;i<data.length;i++) {
      //     var trackObject = self.makeTrackObject(data[i]);
      //     tracksWithVotes.push(trackObject);
      //   }

      //   jwplayer('gvPlayer').load(tracksWithVotes);
      //   self.activePlaylist = tracksWithVotes;
      // });
    },
    /**
     * Play button clicked.  Check state and react
     */
    togglePlay() {
      // this.siPlayer.togglePlay();
      // return;
      const siPlayerState = this.siPlayer.getState();
      this.playerState = siPlayerState;

      // If sample, need to check if we have loaded list
      if (this.isSample && !this.ogClick) {
        this.currentTrack = this.samplePlaylistAndVotes[0];

        this.loadSIWP(this.selectedSample.code, this.samplePlaylistAndVotes, {
          t: this.selectedSample.code,
          track_stream_type_id: 5,
        });

        self.activePlaylist = this.samplePlaylistAndVotes;
        this.activePlaylistURL = this.selectedSample.json_playlist_url;
        this.allowVoting = this.selectedSample.clientweb_interactive;
        // this.shortClipPlaybackTypeID = this.selectedSample.short_clip_playback_type_id;
        this.isInteractive = this.selectedSample.clientweb_interactive;
        this.playlistOrigin = `Sample: ${this.selectedSample.name}`;
        this.playlistOriginRoute = `/samples/${this.selectedSample.id}`;
      }

      // First check if initial click.  Safari needs special attention
      if (!this.ogClick) {
        // document.getElementById('playButton').click();
        this.ogClick = true;
        // this.siPlayer.togglePlay();
      }

      this.siPlayer.togglePlay();
      this.playerState = this.siPlayer.getState();
    },
    /**
     * Shuffle received from samples. Then load and play.
     */
    shuffleSample() {
      this.samplePlaylistAndVotes = shuffle(this.samplePlaylistAndVotes.slice(0, 15));
      this.activePlaylist = this.samplePlaylistAndVotes;
      this.activePlaylistURL = this.selectedSample.json_playlist_url;
      this.allowVoting = this.selectedSample.clientweb_interactive;
      this.isInteractive = this.selectedSample.clientweb_interactive;
      this.shortClipPlaybackTypeID = this.selectedSample.short_clip_playback_type_id;
      this.isSample = true;
      this.isRandomStation = false;

      this.loadSIWP(this.selectedSample.code, this.samplePlaylistAndVotes, {
        t: this.selectedSample.code,
        track_stream_type_id: 5,
      });

      if (!this.ogClick) {
        document.getElementById("playButton").click();
        this.ogClick = true;
        this.siPlayer.play();
      } else {
        this.siPlayer.play();
      }

      this.playerState = "playing";
    },
    /**
     * Handle skip function. Skipping will always play a paused player
     * */
    skipTrack() {
      // this.playerState = 'playing';
      this.siPlayer.next();
    },
    /**
     * Gets votes & comments for current playlist
     *
     * @param
     * @return
     */
    fetchSampleVotes(code) {
      const self = this;
      this.$http.get(`/sample_playlists/${code}`).then((response) => {
        const votes = response.data;
        self.existingVotes = votes;
        // add votes to the playlist
        self.addVotesToPlaylist();
      });
    },
    goHome() {
      this.$router.push("/");
    },
    fetchNewSampleFromID(sampleID) {
      this.selectedSample = "";
      for (let i = 0; i < this.usersSamples.length; i++) {
        if (this.usersSamples[i].id == sampleID) {
          this.selectedSample = this.usersSamples[i];
          // load playlist with votes
          this.getSamplePlaylistTracks();
          return;
        }
      }
    },
    /**
     * If enable/disable voting changed in /players.
     */
    updatePlayerVoting() {
      this.menuLastUpdated = new Date();
    },
    /**
     * DESCRIBE.
     *
     * @param
     * @return
     */
    updateCurrentTrackWithVote(vote) {
      const newTrackCity = this.currentTrack;
      newTrackCity.override_type_id = vote;
      this.$nextTick(function () {
        this.currentTrack = newTrackCity;
      });
    },
    /**
     *load vote reasons
     */
    getVoteReasons() {
      const self = this;
      this.$http.get("/vote/reasons").then((response) => {
        const reasons = response.data;
        self.voteReasons = reasons;
      });
    },
    checkServicesAccess(routeName) {
      let redirect = false;

      if (this.userObject) {
        let showAccounting = false;
        let showUsers = false;

        if (!this.userObject.service_options) {
          return;
        }
        const serviceOptions = this.userObject.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_id == this.accountingServiceTypeID) {
            showAccounting = true;
          }
          if (serviceOptions[i].service_option_id == this.userAdminServiceTypeID) {
            showUsers = true;
          }
          if (serviceOptions[i].service_option_id == this.itServiceTypeID) {
            this.isItMode = true;
          }
        }

        if (routeName == "accounting" && showAccounting == false) {
          redirect = true;
        }
        if (routeName == "users" && showUsers == false) {
          redirect = true;
        }
      }

      if (redirect == true) {
        this.$router.push("/");
      }
    },
    trackManuallySelected(track) {
      if (track.code == this.currentTrack.code) {
        this.siPlayer.pause();
      }

      // If it's the first click, need to play it.
      if (this.ogClick) {
        // document.getElementById('playButton').click();
        this.ogClick = true;
      }

      this.loadSIWP(this.selectedSample.code, this.samplePlaylistAndVotes, {
        t: this.selectedSample.code,
        track_stream_type_id: 5,
      });

      this.activePlaylist = this.samplePlaylistAndVotes;
      this.activePlaylistURL = this.selectedSample.json_playlist_url;
      this.allowVoting = this.selectedSample.clientweb_interactive;
      // this.shortClipPlaybackTypeID = this.selectedSample.short_clip_playback_type_id;
      this.isInteractive = this.selectedSample.clientweb_interactive;
      this.playlistOrigin = `Sample: ${this.selectedSample.name}`;
      this.playlistOriginRoute = `/samples/${this.selectedSample.id}`;
      this.isRandomStation = false;

      //
      let indexer = 0;
      for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
        if (this.samplePlaylistAndVotes[i].code == track.code) {
          this.siPlayer.play();
          this.siPlayer.playlistItem(indexer);
          this.currentTrack = this.samplePlaylistAndVotes[i];
          this.playerState = "playing";
        }

        indexer += 1;
      }
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    closePlayer() {
      this.playerState = null;
      this.activePlaylistURL = null;
      this.currentTrack = null;
      this.shortClipPlaybackTypeID = "0";
    },
    shortClipClicked(isShorty) {
      this.shortClipPlaybackTypeID = isShorty;
    },
    newTrackInfo(track) {
      this.currentTrack = track;
    },
    logout() {
      this.loggedOut = Date.now();
      const self = this;
      this.$http.post("/logout").finally(() => {
        self.clearVars();
        self.userAuthenticated = false;

        self.forcePasswordReset = false;
        window.location.href = "/";

        self.siPlayer.stop();
      });
    },
    clearVars() {
      resetCrispSession();
      localStorage.removeItem("si_access_token");
      localStorage.removeItem("csrf_token");
      this.playlistVotes = "";
      this.playlistTracks = "";
      this.isInteractive = false;
      this.allowVoting = false;
      this.playlistOrigin = "";
      this.playlistOriginRoute = "";
      this.playerState = "paused";
      this.stationCode = "";
      this.currentTrack = "";
      this.shortClipPlaybackTypeID = "";
      this.isSample = "";
      this.isOpen = false;
      this.userObject = {};
      this.userHasOnlinePlayer = false;
      this.accountingServiceTypeID = "11";
      this.userAdminServiceTypeID = "13";
      this.menuLastUpdated = "";
      this.loggedOut = "";
      this.commentIsVisible = false;
      this.voteReasons = "";
      this.selectedSample = "";
      this.samplePlaylistAndVotes = "";
      this.activePlaylistURL = "";
      this.activePlaylist = "";
      this.trackForComment = "";
      this.usersSamples = "";
      this.demoSignupStatusId = "";
      this.demoSignupZoneId = "";
      this.isRandomStation = false;
      this.playlistId = "";
      this.noSamplesNoPlayers = false;
      this.isInitialPlaylistLoad = false;
    },
    checkForDemoSignup(demo_signup_zones) {
      // Get all addresses for all accounts
      let firstDemoZone = null;
      for (const demo_signup_zone in demo_signup_zones) {
        if (Object.prototype.hasOwnProperty.call(demo_signup_zones, demo_signup_zone)) {
          // if (demo_signup_zones.hasOwnProperty(demo_signup_zone)) {
          const ds_zone = demo_signup_zones[demo_signup_zone];

          if (
            ds_zone[0].demo_signup_status_id === 12 ||
            ds_zone[0].demo_signup_status_id === "12" ||
            ds_zone[0].demo_signup_status_id === 13 ||
            ds_zone[0].demo_signup_status_id === "13" ||
            ds_zone[0].demo_signup_status_id === 14 ||
            ds_zone[0].demo_signup_status_id === "14"
          ) {
            if (!firstDemoZone) {
              this.demoSignupStatusId = ds_zone[0].demo_signup_status_id;
              this.demoSignupZoneId = ds_zone[0].location_zone_id;
              firstDemoZone = ds_zone[0];
            }
          }
        }
      }
    },
    fetchUserInfo() {
      const self = this;
      this.$http.get("/user")
      .catch((error) => {
        this.logout()
        return Promise.reject(error)
      })
      .then(
        (response) => {
          self.userObject = response.data;
          self.forcePasswordReset = response.data.force_password_reset;

          if (response.data && response.data.message == "Unauthenticated.") {
            // localStorage.removeItem('si_access_token');
            self.userAuthenticated = false;
            self.forcePasswordReset = false;
            self.userObject = {};
            resetCrispSession();
            return;
          }

          initCrispForUser(self.userObject);

        if (response && response.data && response.data.isJimmyJohns == true) {
          this.$router.push('/jimmyjohns');
        }

        if (response && response.data && response.data.demo_signup_zones) {
          const { demo_signup_zones } = response.data;
          self.checkForDemoSignup(demo_signup_zones);
        }

          self.getLocationZones();
          self.setClickyInfo();
          self.checkServicesAccess(self.$route.name);
          self.logClicky("Entry");

          self.userInfoIsLoaded = true;
        },
        () => {
          self.showOops = false;
          self.userInfoIsLoaded = true;
          // If there was no response, there was an issue so logout and remove all user info
          // self.removeUserAuthentication();
        }
      );
    },
    removeUserAuthentication() {
      resetCrispSession();
      localStorage.removeItem("si_access_token");
      this.userAuthenticated = false;
      this.forcePasswordReset = false;
      this.userObject = {};
    },
    setClickyInfo() {
      // var visitor = {
      //     email: this.userObject.email,
      //     username: this.userObject.first_name + " " + this.userObject.last_name
      // };
      // clicky.setVisitorData(visitor);
    },
    playlistSelected(playlistURLAndContent) {
      this.playerState = "playing";
      this.activePlaylistURL = playlistURLAndContent.url;
      this.playlistOrigin = playlistURLAndContent.origin;
      this.playlistOriginRoute = playlistURLAndContent.route;
      this.playlistTracks = playlistURLAndContent.tracks;
      this.playlistVotes = playlistURLAndContent.votes;
      this.stationCode = playlistURLAndContent.playlist_code;
      this.shortClipPlaybackTypeID = playlistURLAndContent.short_clip_playback_type_id;
      this.isInteractive = playlistURLAndContent.clientweb_interactive;
      this.allowVoting = playlistURLAndContent.allow_voting;
      this.isSample = false;
      this.shuffleIt = new Date();
      this.isRandomStation = false;

      this.loadSIWP(this.stationCode, this.playlistTracks, {
        t: this.selectedSample.code,
        track_stream_type_id: 5,
      });
    },
    playSpotlightStation(playlistURLAndContent) {
      this.playerState = "playing";
      this.activePlaylistURL = playlistURLAndContent.url;
      this.playlistOrigin = playlistURLAndContent.origin;
      this.playlistOriginRoute = playlistURLAndContent.route;
      this.activePlaylist = playlistURLAndContent.tracks;
      this.stationCode = playlistURLAndContent.playlist_code;
      this.shortClipPlaybackTypeID = 0;
      this.isInteractive = false;
      this.allowVoting = false;
      this.isSample = false;
      this.isRandomStation = false;
      this.playlistId = this.activePlaylist.id;

      this.loadSIWP(this.stationCode, this.activePlaylist, {
        player_id: playlistURLAndContent.playlist_code,
        track_stream_type_id: 9,
        l: this.activePlaylist.id,
      });

      this.siPlayer.play();
      this.playerState = "playing";
    },
    toggleSpotlightPlayPause() {
      if (this.siPlayer.getState() == "playing") {
        this.siPlayer.pause();
        this.playerState = "paused";
      } else {
        this.siPlayer.play();
        this.playerState = "playing";
      }
    },
    /**
     * Playlist has been updated with either a vote or comment
     *
     * @param object track
     */
    playlistUpdated(tracks, votes) {
      this.playlistTracks = tracks;
      this.playlistVotes = votes;
    },
    makeBackground() {
      const el = document.body;
      el.className = "";

      if (this.isTpg) {
        el.classList.add("isTpg");
      } else {
        el.classList.add("isGv");

        if (this.mainVueState == PageStates.LOGIN) {
          const randomInt = getRandomInt(1, this.randomBGs.length);
          el.classList.add(`isGv${randomInt}`);
        }
      }
    },
    getPlayerFIdCookie() {
      if (localStorage.getItem("selectedPlayerFId")) {
        return localStorage.getItem("selectedPlayerFId");
      }
    },
    getPlayerTypeIdCookie() {
      if (localStorage.getItem("selectedPlayerTypeId")) {
        return localStorage.getItem("selectedPlayerTypeId");
      }
    },
    /**
     * Initial players call to get only the first 25 players, including the selected player
     *
     * @param bool bypassCookie - flag to bypass using player cookies (default : false)
     * @return bool - return true if successful, otherwise return false
     */
    async getFirstPlayer(bypassCookie=false) {
      let success = true;
      this.isLoadingRemainingPlayers = true;
      let endpoint = "/v3/player/first";

      // attempt to set the initial player to the last selected player
      if (!bypassCookie && this.getPlayerFIdCookie() && this.getPlayerTypeIdCookie()) {
        const playerUniqueId = this.getPlayerFIdCookie();
        const playerTypeId = this.getPlayerTypeIdCookie();
        endpoint += `?foreignId=${playerUniqueId}&playerTypeId=${playerTypeId}`;
      }

      const self = this;
      await this.$http.get(endpoint).then(
        (response) => {
          // check for valid data
          if (
            !response.data ||
            !response.data.data ||
            !response.data.data.players ||
            !Object.keys(response.data.data.players).length ||
            !response.data.data.players.currentTrack ||
            !Object.keys(response.data.data.players.currentTrack).length
          ) {
            success = false;
            return;
          }

          // create instance of first Player
          self.allPlayers = [];
          self.allPlayers = [new Player(response.data.data.players)];

          // check Player object is configured
          if (
            !self.allPlayers.length ||
            !self.allPlayers[0].currentTrack ||
            !Object.keys(self.allPlayers[0].currentTrack).length
          ) {
            this.loadRemainingPlayers(); // T691 - (06-08-2022)
            self.loadSetupState(); // T691 - (06-08-2022)
            success = true;
            return;
          }

          // Checked if this first player is offline - this could be caused by using the players unique ID retrieved in
          // cache (cookies). In this case we will return 'false' if offline and should attempt again setting the bypassCookie
          // parameter. T369 - (07-29-2022)
          if (!bypassCookie && !self.allPlayers[0].isOnline()) {
            localStorage.removeItem("selectedPlayerFId");
            localStorage.removeItem("selectedPlayerTypeId");
            success = false;
            return;
          }

          // T624 get votes (04-13-2022)
          endpoint = "/v3/votes/zone/" + self.allPlayers[0].locationZoneId + this.buildVoteEndpointParams(self.allPlayers[0]);

          this.$http.get(endpoint).then(
            (response) => {
              try {
                self.allPlayers[0].insertVotes(response.data.data.votes);
              } catch (error) {
                console.log(
                  `EXCEPTION WHILE RETRIEVING VOTES FOR PLAYER ${JSON.stringify(response)}`);
              }
            },
            (response) => {
              console.log("ERROR RETRIEVING VOTES FOR PLAYER " + JSON.stringify(response));
            }
          );

          self.loadRemainingPlayers();

          if (self.isOnlinePlayers()) {
            self.userHasOnlinePlayer = true;
            // this.loadRandomStation();
          } else {
            self.loadSetupState();
          }
        },
        () => {
          // console.log("ERROR GETTING PLAYERS " + JSON.stringify(response));
          self.loadRemainingPlayers();
          self.isLoadingRemainingPlayers = false;
        }
      );

      // SI-288 (07-26-2023)
      // Check if failure to get first player and need to get a player to process for first player from /v3/player endpoint
      if (!success) {
        success = await self.getFallbackFirstPlayer();
      }

      return success;
    },
    /**
     * Load the remaining players
     */
    loadRemainingPlayers() {
      this.isLoadingRemainingPlayers = true;
      const self = this;
      this.$http.get("/v3/player").then(
        (response) => {
          if (response && response.data && response.data.data.players) {
            const remainingPlayers = response.data.data.players;

            const firstPlayer = self.allPlayers.length > 0 ? self.allPlayers[0] : null;
            //let cnt = 1;//self.allPlayers.length;
            let cnt = firstPlayer != null ? 1 : 0; // T369 (08-19-2022)

            // Create instances of remaining Player(s)
            remainingPlayers.forEach(function (item) {
              // This endpoint call includes the initial player from the first endpoint call - Do NOT insert the initial player from the first endpoint call
              if (
                firstPlayer &&
                item.esTitle == firstPlayer.esTitle &&
                (item.locationZonePlayerId == firstPlayer.fId() ||
                  item.contactId == firstPlayer.fId())
              ) {
                return; // skip this loop iteration
              }

              // // Player needs to have a current track to be processed
              // if (item.currentTrack && Object.keys(item.currentTrack).length) {
              //   self.allPlayers[cnt++] = new Player(item);
              // }
              self.allPlayers[cnt++] = new Player(item); // Disabled above to allow all client players to display in connectivity page - logic to filter out players with no current track in ChangePlayer vue (T369 - 06-24-2022)
            });

            // // DEBUG
            // Object.keys(self.allPlayers).forEach(key => {
            //     console.log(self.allPlayers[key]);
            // });

            self.isLoadingRemainingPlayers = false;
            self.menuLastUpdated = new Date(); // triggers to update setPlayers() in MainMenu to show the populated dropdown quickly (T225 - 02-04-2022)
          }
        },
        (response) => {
          console.log(`ERROR GETTING PLAYERS ${JSON.stringify(response)}`);
          self.isLoadingRemainingPlayers = false;
        }
      );
    },

    /**
     * SI-288 (07-26-2023)
     * Secondary (recovery) call if first player endpoint returns 'empty' or 'invalid' data. Process of this method calls the players endpoint
     * and retrieves the remaining players and uses the first remaining players 'fid' (LocationZonePlayerId or Contact Id depending on player type)
     * and calls players endpoint and votes to retrieve all necessary player information to display in 'What's Playing'. 
     * 
     * NOTE: The first player call returns all information about the player, however the initial players call only returns a small subset of player
     *       information. Therefore, to retrieve all information of a selected player from the players call requires additional endpoint calls to
     *       complete the retrieval of all player information needed to display in "What's Playing".
     *
     * @return bool - return true if successful, otherwise return false
     */
    async getFallbackFirstPlayer() {
      this.isLoadingRemainingPlayers = true;
      this.allPlayers = [];
      const self = this;

      //
      // Get all remaining players (reduced version of the loadRemainingPlayers method)
      //
      await this.$http.get("/v3/player").then(
        (response) => {
          if (response && response.data && response.data.data.players) {
            const remainingPlayers = response.data.data.players;
            let cnt = 0;

            // Create instances of remaining Player(s)
            remainingPlayers.forEach(function (item) {
              self.allPlayers[cnt++] = new Player(item);
            });
          }
        },
        (response) => {
          console.log(`ERROR GETTING PLAYERS ${JSON.stringify(response)}`);
          self.isLoadingRemainingPlayers = false;
          return false;
        }
      );

      // leave if there are NO remaining players present
      if(!self.allPlayers || self.allPlayers.length === 0 || !self.allPlayers[0].playerTypeId || !self.allPlayers[0].fId()){
        self.isLoadingRemainingPlayers = false;
        return false;
      }

      //
      // Get fallback player from remaining players
      //

      // GET Fallback Player by Type and UniqueId -> /v3/player/{{type}}/{{fId}}
      let endpoint = '/v3/player/' + self.allPlayers[0].playerTypeId + '/'  + self.allPlayers[0].fId();
      //let endpoint = '/v3/player/' + '1' + '/'  + 30151; // TESTING - uncomment above ^^^

      await this.$http.get(endpoint).then((response) => {
        if (!response.data || !response.data.data || !response.data.data.players) {
          return false;
        }
        // override subset of this player's data with a more comprehensive set of the player's data
        self.allPlayers[0] = new Player(response.data.data.players);

        // Get votes for this player
        endpoint = "/v3/votes/zone/" + self.allPlayers[0].locationZoneId + this.buildVoteEndpointParams(self.allPlayers[0]);

        this.$http.get(endpoint).then(
          (response) => {
            try {
              self.allPlayers[0].insertVotes(response.data.data.votes);
            } catch (error) {
              console.log(
                `EXCEPTION WHILE RETRIEVING VOTES FOR PLAYER ${JSON.stringify(response)}`);
            }
          },
          (response) => {
            console.log("ERROR RETRIEVING VOTES FOR PLAYER " + JSON.stringify(response));
          }
        );

        if (self.isOnlinePlayers()) {
          self.userHasOnlinePlayer = true;
        } else {
          self.loadSetupState();
        }

        self.isLoadingRemainingPlayers = false;
        self.menuLastUpdated = new Date(); // triggers to update setPlayers() in MainMenu to show the populated dropdown quickly
      },
      (response) => {
        console.log(`ERROR GETTING FALLBACK PLAYER ${JSON.stringify(response)}`);
        return false;
      });

      return true; // success
    },
    // Setup state is used when the client has no online players
    loadSetupState() {
      this.userHasOnlinePlayer = false;
      this.isLoadingRemainingPlayers = false;
      // this.loadRandomStation();
      this.isRandomStation = false;
    },
    isOnlinePlayers() {
      let result = false;
      if (this.allPlayers && this.allPlayers.length > 0) {
        Object.keys(this.allPlayers).forEach((key) => {
          if (this.allPlayers[key].isOnline()) {
            result = true;
          }
        });
      }

      return result;
    },
    voteCommentClicked(track) {
      const commentTrack = {
        code: track.code,
        title: track.title,
        artist: track.artist,
        file: track.file,
        cover: track.cover,
        genstamp: track.genstamp,
        updated: new Date(),
        comment: track.comment,
        vote_reason_id: track.vote_reason_id,
        override_type_id: track.override_type_id,
      };

      this.trackForComment = commentTrack;
      this.showVoteModal = true;
      // this.$refs.commentModal.show();
    },
    saveComment(voteReasonAndComment) {
      // No info, no need to save
      if (!voteReasonAndComment.selectedReasonID && !voteReasonAndComment.comment) {
        return;
      }

      // Save vote reason
      if (voteReasonAndComment.selectedReasonID) {
        const trackWithComment = Querystring.stringify({
          station_code: this.selectedSample.code,
          track_code: voteReasonAndComment.track.code,
          vote_reason_id: voteReasonAndComment.selectedReasonID,
          comment: voteReasonAndComment.comment,
        });

        this.$http.post("/station/vote/reason", trackWithComment).then(() => {});
      }

      // Save the comment
      if (voteReasonAndComment.comment && !voteReasonAndComment.selectedReasonID) {
        const trackWithComment2 = Querystring.stringify({
          station_code: this.selectedSample.code,
          track_code: voteReasonAndComment.track.code,
          comment: voteReasonAndComment.comment,
        });

        this.$http.post("/station/vote/comment", trackWithComment2).then(() => {});
      }

      // Update in playlist and current track
      for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
        if (this.samplePlaylistAndVotes[i].code == voteReasonAndComment.track.code) {
          this.samplePlaylistAndVotes[i].comment = voteReasonAndComment.comment;
          this.samplePlaylistAndVotes[i].vote_reason_id =
            voteReasonAndComment.selectedReasonID;
        }

        if (this.samplePlaylistAndVotes[i].code == this.currentTrack.code) {
          this.currentTrack.comment = voteReasonAndComment.comment;
          this.currentTrack.vote_reason_id = voteReasonAndComment.selectedReasonID;
        }
      }

      const event_data = {
        web_tracking_event_type_id: 3,
        page_name: `${this.selectedSample.name} Sample List comment`,
        location_zone_id: "",
        track_code: voteReasonAndComment.track.code,
        contact_login_station_id: this.selectedSample.id,
        vote_value: "",
        session_token: "",
      };
      if (voteReasonAndComment.comment) {
        event_data.message = { comment: voteReasonAndComment.comment };
      }

      this.logEvent(event_data);
    },
    deleteComment(track) {
      for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
        if (this.samplePlaylistAndVotes[i].code == track.code) {
          this.samplePlaylistAndVotes[i].comment = "";
          this.samplePlaylistAndVotes[i].vote_reason_id = "";
        }

        if (this.samplePlaylistAndVotes[i].code == this.currentTrack.code) {
          this.currentTrack = this.samplePlaylistAndVotes[i];
        }
      }

      this.$http
        .delete(`/station/vote/comment/${this.selectedSample.code}/${track.code}`)
        .then(() => {});

      this.$http
        .delete(`/station/vote/reason/${this.selectedSample.code}/${track.code}`)
        .then(() => {});
    },
    newPlaylistVotes(playlistVotes) {
      this.playlistVotes = playlistVotes;
    },
    /**
     * Handle vote click. Checks if same as last and deletes accordingly
     *
     * @param object track, int loveOrLeave (love=1, leave=0)
     * @return this.makeVote()
     */
    // voteClicked: function(track,vote) {

    // if (track.vote == loveOrLeave) {
    //   if (this.canDeleteVote(track)) {
    //     this.deleteSampleVote(track);
    //     this.updateSamplePlaylistVote(track,'');
    //   } else {
    //     this.updateSamplePlaylistVote(track,'-1');
    //   }

    // } else {
    //   this.updateSamplePlaylistVote(track,loveOrLeave);
    // }

    // //Update current track if selected
    // if (track.code == this.currentTrack.code) {
    //   this.currentTrack['override_type_id'] = loveOrLeave;
    // }

    // },
    setCommentTimeout() {
      const self = this;
      setTimeout(() => {
        self.commentIsVisible = false;
        self.voteCommentText = "";
      }, 5000);
    },
    /**
     * T646 - (04-22-2022)
     * Builds the tracks code string for the votes-zone endpoint
     *
     * @param currentPlayer - current player (Player object)
     * @return string
     */
    buildVoteEndpointParams(currentPlayer) {
      if (
        !currentPlayer ||
        !currentPlayer.currentTrack ||
        !currentPlayer.currentTrack.code
      ) {
        return "";
      }

      let buildStr = "";
      try {
        const currentTrack = currentPlayer.currentTrack;
        const lastFive = currentPlayer.lastFive ? currentPlayer.lastFive : [];
        buildStr = "?trackCode[]=" + currentTrack["code"];

        Object.keys(lastFive).forEach((key) => {
          buildStr += "&trackCode[]=" + lastFive[key]["code"];
        });
      } catch (error) {
        console.log(`EXCEPTION WHILE BUILDING VOTE ENDPOINT PARAMS: error -> ${error}`);
        buildStr = "";
      }

      return buildStr;
    },
  },
  computed: {
    mainVueState() {
      const routeName = this.$route.name;

      if (!this.userAuthenticated) {
        if (routeName == "password_reset") {
          return PageStates.FORGOT;
        }
        return PageStates.LOGIN;
      }
      if (this.userAuthenticated) {
        if (this.forcePasswordReset == 1) {
          return PageStates.FORCE_PASSWORD_RESET;
        }
        return PageStates.WORKSPACE;
      }

      return PageStates.WORKSPACE;
    },
    voteReasonGroup() {
      return this.voteReasons.positive;
    },
    logoColor() {
      let color = "#000";
      if (!this.userAuthenticated) {
        if (this.mainVueState == "FORGOT") {
          color = "#000";
        } else {
          color = "#000";
        }
      }

      return color;
    },
  },
  watch: {
    // Check for demo_signup status
    locationZones() {
      if (!this.demoSignupZoneId || !this.demoSignupStatusId) return;
      // If still waiting on client, send to demo signup
      if (
        this.demoSignupStatusId === 12 ||
        this.demoSignupStatusId === "12" ||
        this.demoSignupStatusId === 13 ||
        this.demoSignupStatusId === "13" ||
        this.demoSignupStatusId === 14 ||
        this.demoSignupStatusId === "14"
      ) {
        let location_id = "";
        for (let i = 0; i < this.locationZones.length; i++) {
          if (this.locationZones[i].location_zone_id == this.demoSignupZoneId) {
            location_id = this.locationZones[i].location_id;

            // Forward to edit location form
            if (this.$route.path == "/" && this.isItMode == false) {
              this.$router.push({ name: "edit-location", params: { id: location_id } });
            }
          }
        }
      }
    },
    userAuthenticated() {
      this.makeBackground();
    },
    $route() {
      const routeName = this.$route.name;
      routeName ? this.open() : this.close();

      this.checkServicesAccess(routeName);

      // If samples only, get new sample
      if (routeName == "sample" && this.$route.params.id != this.selectedSample.id) {
        this.fetchNewSampleFromID(this.$route.params.id);
      }
      // this.logClicky("Menu click");
      let routeString = "Home";
      if (routeName) {
        routeString = routeName;
      }
      const event_data = {
        web_tracking_event_type_id: 2,
        page_name: routeString,
        location_zone_id: "",
        track_code: "",
        contact_login_station_id: "",
        vote_value: "",
        session_token: "",
        message: "",
      };
      this.logEvent(event_data);
    },
  },
};

function shuffle(a) {
  let j;
  let x;
  let i;
  for (i = a.length; i; i--) {
    j = Math.floor(Math.random() * i);
    x = a[i - 1];
    a[i - 1] = a[j];
    a[j] = x;
  }

  return a;
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
</script>

<style>
.content-line {
  transition: 0.3s;
}

.content-line.lineIsOpen {
  position: fixed;
  top: 0px;
  left: 430px;
  height: 100vh;
  width: 1px;
  border-left: 0px solid #bcbcbc;
  height: 100vh;
}

.workspace-container {
  position: relative;
  width: 100%;
  left: 438px;
  /* transition: all .3s ease; */
  max-width: 850px;
  /*    height:100vh;*/
  padding-left: 20px;
}

.workspace-content {
  width: 850px;
  padding: 20px;
  height: auto;
  overflow: hidden;
  padding-bottom: 30px;
}

.midtempo-link {
  position: fixed;
  visibility: visible;
  bottom: 20px;
  left: 24px;
}

.midtempo-link a {
  color: white;
  text-decoration: none;
}

.midtempo-link a:hover {
  color: yellow;
}

.midtempo-link a:active {
  text-decoration: none;
}

.workspace-slide-enter-active {
  animation: workspace-slide-in 0.2s;
}

.workspace-slide-leave-active {
  animation: workspace-slide-out 0.2s;
}

@keyframes workspace-slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    width: 100%;
    /*    left:515px;*/
  }
}

@keyframes workspace-slide-out {
  100% {
    transform: translateX(100%);
  }
}

.sublink-container {
  width: 850px;
  text-align: right;
  height: 14px;
  line-height: 14px;
  clear: both;
  margin-top: -14px;
}

.sublink {
  font-size: 13px;
  transition: 0.3s;
  cursor: pointer;
}

.sublink span {
  padding-right: 5px;
}

.menu-container {
  width: 755px;
  margin: 0 auto;
  margin-top: 100px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.menu-container.isOpen {
  width: 375px;
  margin-left: 0px;
  padding-left: 27px;
}

@media (max-width: 1200px) {
  .content-line {
    display: none;
  }
  .workspace-container {
    border: 0px;
    margin: 0 auto;
  }
  .workspace-content {
    margin: 0 auto;
  }
  .workspace-container.isOpen {
    left: 0px;
  }
  .menu-container.isOpen {
    left: -500px;
  }
  .menu-contracted {
    opacity: 0;
  }
  .midtempo-link {
    /* position:absolute; */
    visibility: hidden;
    left: -100px;
    display: none;
  }
}

@media (max-width: 1200px) and (min-width: 768px) {
  .workspace-container {
    padding-left: 0px;
    margin: 0 auto;
  }
  .workspace-content {
    width: 768px;
    margin-top: 20px;
    padding: 10px;
  }
  .sublink-container {
    width: 768px;
    margin: 0 auto;
  }
  .content-line {
    display: none;
  }
}

@media (max-width: 768px) {
  .workspace-container {
    width: 100%;
    padding: 0px;
    clear: both;
  }
  .workspace-content {
    width: 100%;
    clear: both;
    padding: 10px;
    border-radius: 0px;
  }
  .menu-container {
    width: 98%;
    margin: 0 auto;
    position: relative;
  }
  .menu-container.isOpen {
    left: -500px;
    display: none;
  }
  .sublink-container {
    width: 96%;
    margin: 0 auto;
  }
  .content-line {
    display: none;
  }
  .midtempo-link {
    position: relative;
    visibility: visible;
    bottom: 20px;
    left: 24px;
    font-size: 14px;
  }
}

.player-slide-up-enter-active,
.player-slide-up-leave-active {
  transition: opacity 0.3s;
}

.player-slide-up-enter,
.player-slide-up-leave-to {
  opacity: 0;
}

.goHome {
  cursor: pointer;
}

.vote-comment {
  position: fixed;
  top: 0;
  width: 120px;
  left: 50%;
  margin-left: -60px;
  background-color: rgba(169, 169, 169, 0.5);
  border-radius: 1px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  height: 0px;
  line-height: 30px;
  text-align: center;
  transition: 0.1s;
  visibility: hidden;
  z-index: 110;
}

.vote-comment.isVisible {
  height: 30px;
  visibility: visible;
}

.in-process {
  background-color: rgba(169, 169, 169, 0.5);
  color: white;
  width: 50%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 5px;
}

.midtempo-link {
  position: fixed;
  visibility: visible;
  bottom: 20px;
  left: 24px;
  font-size: 14px;
  font-weight: bold;
}

.midtempo-link.playerIsOpen {
  bottom: 48px;
}

.midtempo-link a {
  color: white;
  text-decoration: none;
}

.midtempo-link.isTpg a:hover {
  color: rgba(1, 172, 129, 1);
}

.midtempo-link a:hover {
  color: yellow;
}

.midtempo-link a:active {
  text-decoration: none;
}

.midtempo-link-svg:hover {
  fill: yellow;
}
</style>
